import request from './common/request'
import qs from 'qs'

import { MERCHANT_EVALUATION_SCHEME_CONFIG_URI } from './urls'

// 列表
async function list (params) {
  return request(
    {
      url: MERCHANT_EVALUATION_SCHEME_CONFIG_URI,
      method: 'GET',
      params
    }
  )
}

// 详情
async function getById (id) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_SCHEME_CONFIG_URI}/${id}`,
      method: 'GET'
    }
  )
}

// 插入
async function insert (data) {
  return request(
    {
      url: MERCHANT_EVALUATION_SCHEME_CONFIG_URI,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

// 更新
async function update (data) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_SCHEME_CONFIG_URI}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

// 删除
async function remove (id) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_SCHEME_CONFIG_URI}/${id}`,
      method: 'DELETE'
    }
  )
}

async function listItems (params) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_SCHEME_CONFIG_URI}/${params.schemeCfgId}/items`,
      method: 'GET',
      params
    }
  )
}

async function addItem (data) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_SCHEME_CONFIG_URI}/${data.schemeCfgId}/items`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

async function updateItem (data) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_SCHEME_CONFIG_URI}/${data.schemeCfgId}/items/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

async function getItem (data) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_SCHEME_CONFIG_URI}/${data.schemeCfgId}/items/${data.id}`,
      method: 'GET'
    }
  )
}

async function removeItem (data) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_SCHEME_CONFIG_URI}/${data.schemeCfgId}/items/${data.id}`,
      method: 'DELETE'
    }
  )
}

export default {
  list,
  getById,
  insert,
  update,
  remove,
  listItems,
  addItem,
  updateItem,
  getItem,
  removeItem
}



// WEBPACK FOOTER //
// ./src/api/merchant-evaluation-scheme-config.js